import { render } from "./AdminPrestations.vue?vue&type=template&id=147a0adb&scoped=true"
import script from "./AdminPrestations.vue?vue&type=script&lang=js"
export * from "./AdminPrestations.vue?vue&type=script&lang=js"

import "./AdminPrestations.vue?vue&type=style&index=0&id=147a0adb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-147a0adb"]])

export default __exports__